// This file was automatically generated from render.chartFeedItem.visitNoteTemplate.twoCol.html.
// Please don't edit this file by hand.

goog.provide('el8.template.render.chartFeedItem.visitNoteTemplate.twoCol');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.render.chartFeedItem.visitNoteContent');
goog.require('el8.template.render.chartFeedItem.visitNoteShared');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="cardColumn w100"><div class="cardColumn w49 fr">');
  el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionObjective(soy.$$augmentData(opt_data.objective, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
  if (opt_data.templateTypeMap.assessplan) {
    el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionAssessplan({feedItemId: opt_data.feedItemId, assessplans: opt_data.assessment.assessplans, instructions: opt_data.plan.instructions, orders: opt_data.plan.orders, procedures: opt_data.plan.procedures, templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}, output);
  } else {
    el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionAssessment(soy.$$augmentData(opt_data.assessment, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
    el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionPlan(soy.$$augmentData(opt_data.plan, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
  }
  output.append('</div><div class="cardColumn w50">');
  el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionSubjective(soy.$$augmentData(opt_data.subjective, {templateTypeMap: opt_data.templateTypeMap, isEdit: opt_data.isEdit}), output);
  output.append('</div>');
  el8.template.render.chartFeedItem.visitNoteContent.sectionFollowup({followup: opt_data.followup}, output);
  output.append('</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionSubjective = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.problems.length > 0 || opt_data.pastItems.length > 0 || opt_data.surgicalItems.length > 0 || opt_data.allergies.length > 0 || opt_data.habitsItems.length > 0 || opt_data.familyItems.length > 0 || opt_data.socialItems.length > 0 || opt_data.vniMeds.length > 0 || opt_data.rosItems.length > 0 || opt_data.rosDetails.length > 0) {
    output.append('<fieldset class="noBorderForm"><h4 class="el8SectionHeaderNoCollapse">Subjective</h4>');
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.problems, collapsible: false, type: opt_data.templateTypeMap.problem, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.allergies, label: 'Allgy:', type: opt_data.templateTypeMap.allergies, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.pastItems, label: 'PMH:', type: opt_data.templateTypeMap.past, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.surgicalItems, label: 'PSH:', type: opt_data.templateTypeMap.surgical, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'FH:', items: opt_data.familyItems, type: opt_data.templateTypeMap.family, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'SH:', items: opt_data.socialItems, type: opt_data.templateTypeMap.social, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Habits:', items: opt_data.habitsItems, type: opt_data.templateTypeMap.habits, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Meds:', items: opt_data.vniMeds, type: opt_data.templateTypeMap.med, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.checklist({label: 'ROS:', items: opt_data.rosItems, details: opt_data.rosDetails, type: opt_data.templateTypeMap.ros}, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionObjective = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.allDatas.length > 0 || opt_data.peItems.length > 0 || opt_data.peDetails.length > 0 || opt_data.vitals.hasVitals) {
    output.append('<fieldset class="noBorderForm"><h4 class="el8SectionHeaderNoCollapse">Objective</h4>');
    el8.template.render.chartFeedItem.visitNoteContent.sectionVitals(opt_data.vitals, output);
    el8.template.render.chartFeedItem.visitNoteShared.checklist({label: 'PE:', items: opt_data.peItems, details: opt_data.peDetails, type: opt_data.templateTypeMap.pe}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.allDatas, label: 'Data:', type: opt_data.templateTypeMap.data, isEdit: opt_data.isEdit}, output);
    output.append('</fieldset>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionAssessment = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.assessments.length > 0) {
    output.append('<fieldset class="noBorderForm"><h4 class="el8SectionHeaderNoCollapse">Assessment</h4>');
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.assessments, collapsible: false, feedItemId: opt_data.feedItemId, isAssessment: true, type: opt_data.templateTypeMap.assessment, isEdit: opt_data.isEdit}, output);
    output.append('</fieldset>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionPlan = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.tests.length > 0 || opt_data.txs.length > 0 || opt_data.instructions.length > 0 || opt_data.procedures.length > 0) {
    output.append('<fieldset class="noBorderForm"><h4 class="el8SectionHeaderNoCollapse">Plan</h4>');
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Tests:', items: opt_data.tests, collapsible: false, type: opt_data.templateTypeMap.test, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Tx:', items: opt_data.txs, collapsible: false, type: opt_data.templateTypeMap.tx, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Proc:', items: opt_data.procedures, collapsible: false, type: opt_data.templateTypeMap.procedure, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Care Plan:', items: opt_data.instructions, collapsible: false, type: opt_data.templateTypeMap.instr, isEdit: opt_data.isEdit, isOneCol: true}, output);
    output.append('</fieldset>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.render.chartFeedItem.visitNoteTemplate.twoCol.sectionAssessplan = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.assessplans.length > 0 || opt_data.instructions.length > 0 || opt_data.orders.length || opt_data.procedures.length > 0) {
    output.append('<fieldset class="noBorderForm"><h4 class="el8SectionHeaderNoCollapse">Assessment/Plan</h4>');
    el8.template.render.chartFeedItem.visitNoteShared.field({items: opt_data.assessplans, collapsible: false, feedItemId: opt_data.feedItemId, isAssessment: true, type: opt_data.templateTypeMap.assessplan, isEdit: opt_data.isEdit}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Care Plan:', items: opt_data.instructions, collapsible: false, type: opt_data.templateTypeMap.instr, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Proc:', items: opt_data.procedures, collapsible: false, type: opt_data.templateTypeMap.procedure, isEdit: opt_data.isEdit, isOneCol: true}, output);
    el8.template.render.chartFeedItem.visitNoteShared.field({label: 'Orders:', items: opt_data.orders, collapsible: false, type: opt_data.templateTypeMap.orders, isEdit: opt_data.isEdit}, output);
    output.append('</fieldset>');
  }
  if (!opt_sb) return output.toString();
};
